module.exports = __webpack_public_path__ + "static/img/wyc.f56b83a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deal-manage/wyc.png
// module id = nZd1
// module chunks = 0